import type {HeaderPageData} from '../page-data/payloads/header'
import {PullRequestHiddenCharactersBanner} from './banners/PullRequestHiddenCharactersBanner'
import {PullRequestAutomatedSecurityUpdateBanner} from './banners/PullRequestAutomatedSecurityUpdateBanner'
import {PullRequestPausedDependabotBanner} from './banners/PullRequestPausedDependabotBanner'
import {PullRequestState} from '../types'

export function PullRequestBanners({
  bannersData,
  pullRequest,
  repository,
}: Pick<HeaderPageData, 'bannersData' | 'pullRequest' | 'repository'>) {
  return (
    <>
      {bannersData.banners.hiddenCharacterWarning.render && (
        <PullRequestHiddenCharactersBanner pullRequest={pullRequest} />
      )}
      {bannersData.banners.pausedDependabotUpdate.render && (
        <PullRequestPausedDependabotBanner repository={repository} />
      )}
      {bannersData.banners.dependabotAutomatedSecurityUpdates.render && pullRequest.state === PullRequestState.Open && (
        <PullRequestAutomatedSecurityUpdateBanner
          dependabotUpdates={bannersData.banners.dependabotAutomatedSecurityUpdates}
          pullRequest={pullRequest}
        />
      )}
    </>
  )
}
